import { graphql, HeadProps } from 'gatsby';
import React, { ReactElement } from 'react';
import AbTestingService from 'src/elements/abTesting/abTesting.service';
import { HeadComponent } from 'src/elements/Layout/head';
import HomepageView, { HomepageProps } from 'src/views/2024_Q4/homepage';

const IndexPage = (props: HomepageProps): ReactElement => {
  return AbTestingService<HomepageProps['data'], HomepageProps['data']>({
    props,
    control: {
      data: props.data,
      template: HomepageView,
    },
  });
};

export default IndexPage;

export const Head = (props: HeadProps<HomepageProps['data']>): JSX.Element => {
  const helmet = {
    title: props.data.contentfulPage.seoTitle,
    description: props.data.contentfulPage.seoDescription,
    previewImageURL: props.data.contentfulPage.seoImage?.file?.url,
  };

  const canonicalTagSlug = props.data.contentfulPage.canonicalTagSlug
    ? `/${props.data.contentfulPage.canonicalTagSlug}`
    : null;

  return (
    <HeadComponent
      helmet={helmet}
      location={props.location}
      canonicalTagSlug={canonicalTagSlug}
    />
  );
};

export const pageQuery = graphql`
  query LandingPageQuery {
    contentfulPage(contentful_id: { eq: "1B0YZp1jcsutysEYjA1sns" }) {
      title
      seoTitle
      seoDescription
      canonicalTagSlug
      seoImage {
        file {
          url
        }
      }
    }
  }
`;
